import { render, staticRenderFns } from "./CourseCopy.vue?vue&type=template&id=7a07ad54&"
import script from "./CourseCopy.vue?vue&type=script&lang=js&"
export * from "./CourseCopy.vue?vue&type=script&lang=js&"
import style0 from "./CourseCopy.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.7.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports